module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/consultants-small.f54bd330152678d6f6a0f127134e0bba.jpg";